import React, { useMemo, memo } from "react";
import "./RatingDetails.css";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "../UI/Table";
import { useTooltip } from "../../hooks/useTooltip";

const RatingDetails = ({ ratings }) => {
  const { showTooltip, hideTooltip } = useTooltip();

  const passFailSummary = useMemo(() => {
    let passCount = 0;
    let failCount = 0;
    ratings.forEach((rating) => {
      if (rating.RatingEnum === "Pass") passCount++;
      else if (rating.RatingEnum === "Fail") failCount++;
    });
    return `Pass: ${passCount} Fail: ${failCount}`;
  }, [ratings]);

  return (
    <div className="rating-details">
      <div className="rating-header">
        <h3>Ratings</h3>
        <h4>{passFailSummary}</h4>
      </div>

      <Table className="nested-table">
        <TableHeader>
          <TableCell header></TableCell>
          <TableCell header>ID</TableCell>
          <TableCell header>Name</TableCell>
          <TableCell header>Pass/Fail</TableCell>
          <TableCell header>Reason</TableCell>
        </TableHeader>
        <TableBody>
          {ratings.map((rating, index) => (
            <TableRow key={index} className="request-row">
              <TableCell>
                <div
                  className="rating-description"
                  onMouseEnter={(e) => showTooltip(e, rating.RatingDescription)}
                  onMouseLeave={hideTooltip}
                >
                  <span className="tooltip-indicator">ℹ️</span>
                </div>
              </TableCell>
              <TableCell>{rating.RatingId}</TableCell>
              <TableCell>{rating.RatingName}</TableCell>
              <TableCell
                className={`rating-enum rating-enum--${rating.RatingEnum?.toLowerCase()}`}
              >
                {rating.RatingEnum}
              </TableCell>
              <TableCell>{rating.RatingReason}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default memo(RatingDetails);
